import { translationKey } from '../i18n';
import { localize } from '../i18n';
import SingleLineText from './ui/SingleLineText';
import Button from './ui/FitButton';
import React from 'react';
import { Box, Typography } from '@mui/material';
import RateReviewIcon from '@mui/icons-material/RateReview';
import BottomSheet from './BottomSheet';

export default function StoreReviewSheet({ open, onClose, onReview, source = 'unknown' }) {
    const title = source === 'monthly_recap'
        ? translationKey('이번 달도 꾸준히 챙겼어요')
        : translationKey('이번에도 잊지 않도록 챙겼어요');

    return (
        <BottomSheet open={open} onClose={onClose}>
            <Box sx={{
                width: 54, height: 54, borderRadius: '18px',
                bgcolor: '#fff7cc', color: '#8a7000',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                mb: 2,
            }}>
                <RateReviewIcon sx={{ fontSize: 28 }} />
            </Box>

            <SingleLineText sx={{ fontSize: '1.28rem', fontWeight: 800, color: '#1a1a1a', lineHeight: 1.35, mb: 1 }}>
                {localize(title)}
            </SingleLineText>
            <Typography sx={{ fontSize: '1.02rem', fontWeight: 600, color: '#666', lineHeight: 1.65, mb: 2.5 }}>{localize("약 챙기기에 도움이 되고 있다면")}<br />{localize("짧은 리뷰로 응원해주세요.")}</Typography>

            <Button
                variant="contained"
                fullWidth
                onMouseDown={(e) => e.preventDefault()}
                onClick={onReview}
                sx={{
                    py: 1.55,
                    bgcolor: '#ffe566',
                    color: '#5a4a00',
                    borderRadius: 3,
                    fontSize: '1rem',
                    fontWeight: 800,
                    boxShadow: '0 4px 12px rgba(230,168,0,0.24)',
                    '&:hover': { bgcolor: '#e8d040' },
                    mb: 1,
                }}
            >{localize("리뷰 남기기")}</Button>
            <Button
                variant="outlined"
                fullWidth
                onMouseDown={(e) => e.preventDefault()}
                onClick={onClose}
                sx={{
                    py: 1.35,
                    bgcolor: '#fff',
                    color: '#555',
                    borderColor: '#e5e7eb',
                    borderRadius: 3,
                    fontSize: '1rem',
                    fontWeight: 700,
                    '&:hover': {
                        bgcolor: '#fafafa',
                        borderColor: '#d1d5db',
                    },
                }}
            >{localize("나중에")}</Button>
        </BottomSheet>
    );
}
